import {
	SCHEMA_BOOL_COMP_PROP,
	SCHEMA_NUM_COMP_PROP,
	SCHEMA_STRING_COMP_PROP,
	SCHEMA_VALIDATION,
} from '../../constants';
import {
	ComponentPropertyDefinition,
	ComponentPropertyEditor,
	ComponentPropertyGroup,
	ComponentStylePropertyDefinition,
} from '../../types/common';
import { COMMON_COMPONENT_PROPERTIES, COMPONENT_STYLE_GROUP_PROPERTIES } from '../util/properties';

const propertiesDefinition: Array<ComponentPropertyDefinition> = [
	COMMON_COMPONENT_PROPERTIES.analyticsLabel,
	{
		...COMMON_COMPONENT_PROPERTIES.designType,
		enumValues: [
			{ name: 'button', displayName: 'Button to open browser' },
			{ name: 'browser', displayName: 'Full browser' },
			{ name: 'fileUploadWithProgressBar', displayName: 'File Upload With Progress Bar' },
		],
		defaultValue: 'button',
	},
	COMMON_COMPONENT_PROPERTIES.colorScheme,
	{
		name: 'resourceType',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'Resource Type',
		defaultValue: 'static',
		enumValues: [
			{ name: 'static', displayName: 'Static' },
			{ name: 'secured', displayName: 'Secured' },
		],
		group: ComponentPropertyGroup.BASIC,
	},
	{
		name: 'hideCreateFolder',
		schema: SCHEMA_BOOL_COMP_PROP,
		displayName: 'Hide Create Folder',
		group: ComponentPropertyGroup.BASIC,
	},
	{
		name: 'hideUploadFile',
		schema: SCHEMA_BOOL_COMP_PROP,
		displayName: 'Hide Upload File',
		group: ComponentPropertyGroup.BASIC,
	},
	{
		name: 'hideDelete',
		schema: SCHEMA_BOOL_COMP_PROP,
		displayName: 'Hide Delete',
		group: ComponentPropertyGroup.BASIC,
	},
	{
		name: 'hideEdit',
		schema: SCHEMA_BOOL_COMP_PROP,
		displayName: 'Hide Edit',
		group: ComponentPropertyGroup.BASIC,
	},
	{
		name: 'cropToWidth',
		schema: SCHEMA_NUM_COMP_PROP,
		displayName: 'Crop to Width in pixels',
		group: ComponentPropertyGroup.BASIC,
	},
	{
		name: 'cropToHeight',
		schema: SCHEMA_NUM_COMP_PROP,
		displayName: 'Crop to Height in pixels',
		group: ComponentPropertyGroup.BASIC,
	},
	{
		name: 'cropToAspectRatio',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'Crop to Aspect Ratio (width:height)',
		description:
			'Aspect ratio to crop the image to in the format width:height, or just size to crop to a square',
		group: ComponentPropertyGroup.ADVANCED,
	},
	{
		name: 'cropToMaxWidth',
		schema: SCHEMA_NUM_COMP_PROP,
		displayName: 'Crop to Max Width',
		group: ComponentPropertyGroup.ADVANCED,
	},
	{
		name: 'cropToMaxHeight',
		schema: SCHEMA_NUM_COMP_PROP,
		displayName: 'Crop to Max Height',
		group: ComponentPropertyGroup.ADVANCED,
	},
	{
		name: 'cropToMinWidth',
		schema: SCHEMA_NUM_COMP_PROP,
		displayName: 'Crop to Min Width',
		group: ComponentPropertyGroup.ADVANCED,
	},
	{
		name: 'cropToMinHeight',
		schema: SCHEMA_NUM_COMP_PROP,
		displayName: 'Crop to Min Height',
		group: ComponentPropertyGroup.ADVANCED,
	},
	{
		name: 'selectionType',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'Selection Type',
		defaultValue: '_files',
		enumValues: [
			{ name: '_files', displayName: 'Files only' },
			{ name: '_folders', displayName: 'Folders only' },
			{ name: '_both', displayName: 'Files and Folders' },
		],
		group: ComponentPropertyGroup.ADVANCED,
	},
	{
		name: 'fileCategory',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'File Category',
		enumValues: [
			{ name: '', displayName: 'All' },
			{ name: 'FILES', displayName: 'Files Only' },
			{ name: 'DIRECTORIES', displayName: 'Folders Only' },
			{ name: 'ARCHIVE', displayName: 'Archive types' },
			{ name: 'DOCUMENTS', displayName: 'Documents' },
			{ name: 'IMAGES', displayName: 'Images' },
			{ name: 'VIDEOS', displayName: 'Videos' },
		],
		multiValued: true,
		group: ComponentPropertyGroup.ADVANCED,
	},
	{
		name: 'restrictSelectionType',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'Restrict Selection File Type',
		multiValued: true,
	},
	{
		name: 'restrictUploadType',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'Restrict Upload File Type',
		multiValued: true,
	},
	{
		name: 'fileUploadSizeLimit',
		schema: SCHEMA_NUM_COMP_PROP,
		displayName: 'File Upload Size Limit (MB)',
		defaultValue: 0,
	},
	{
		name: 'uploadImage',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'Image to show for upload prompt',
		editor: ComponentPropertyEditor.IMAGE,
		group: ComponentPropertyGroup.BASIC,
	},
	 {
  name: 'uploadButtonText',
  schema: SCHEMA_STRING_COMP_PROP,
  displayName: 'Upload Button Text',
  description: 'Text to display on the upload button',
  defaultValue: 'Upload File',
  group: ComponentPropertyGroup.BASIC,
 },

 {
  name: 'UploadPlaceholderText',
  schema: SCHEMA_STRING_COMP_PROP,
  displayName: 'Upload Placeholder Text',
  description: 'Placeholder text for the upload area',
  defaultValue: 'Upload documents or images',
  group: ComponentPropertyGroup.BASIC,
 },
 	{
		name: 'label',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'Label',
		description: 'Text label displayed above the file selector',
		defaultValue: 'Label',
		group: ComponentPropertyGroup.BASIC,
    },
	{
		name: 'removeImage',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'Image to show for remove prompt',
		editor: ComponentPropertyEditor.IMAGE,
		group: ComponentPropertyGroup.BASIC,
	},
	{
		name: 'startLocation',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'Start Location',
		group: ComponentPropertyGroup.BASIC,
	},
	{
		name: 'restrictNavigationToTopLevel',
		schema: SCHEMA_BOOL_COMP_PROP,
		displayName: 'Restrict Navigation to folders above',
		defaultValue: false,
		group: ComponentPropertyGroup.ADVANCED,
	},
	{
		name: 'editOnUpload',
		schema: SCHEMA_BOOL_COMP_PROP,
		displayName: 'Edit on Upload',
		defaultValue: false,
		group: ComponentPropertyGroup.BASIC,
	},
	{
		name: 'clientCode',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'Client Code',
		description: 'Provide the client code to access the client files',
		group: ComponentPropertyGroup.BASIC,
	},
	{
		name: 'fullUrl',
		schema: SCHEMA_BOOL_COMP_PROP,
		displayName: 'Store the full URL',
		description:
			'Store an absolute URL instead of the files-API path: the CDN host when one ' +
			'is configured, otherwise this page\'s own origin. Needed wherever the value ' +
			'leaves the app, such as a PWA manifest, an email or an API payload. Either ' +
			'way the value stored is a URL string - browsing and uploading agree.',
		defaultValue: false,
		group: ComponentPropertyGroup.ADVANCED,
	},
	{
		name: 'validation',
		schema: SCHEMA_VALIDATION,
		displayName: 'Validation',
		description: 'Validation Rule',
		editor: ComponentPropertyEditor.VALIDATION,
		group: ComponentPropertyGroup.VALIDATION,
		validationList: [{ name: 'MANDATORY', displayName: 'File Selection Mandatory' }],
		multiValued: true,
	},
	COMMON_COMPONENT_PROPERTIES.onSelect,
	COMMON_COMPONENT_PROPERTIES.readOnly,
	COMMON_COMPONENT_PROPERTIES.visibility,
	{
		name: 'allowMultipleSelection',
		schema: SCHEMA_BOOL_COMP_PROP,
		displayName: 'Allow Multiple Selection',
		description: 'Allow multiple files to be selected and if there is an edit option',
		defaultValue: false,
		group: ComponentPropertyGroup.BASIC,
	},
	{
		name: 'fileUploadPlaceholderText',
		schema: SCHEMA_STRING_COMP_PROP,
		displayName: 'File Upload Placeholder Text',
		group: ComponentPropertyGroup.BASIC,
		defaultValue: 'Upload docx here',
	},
];

const stylePropertiesDefinition: ComponentStylePropertyDefinition = {
	'': [
		COMPONENT_STYLE_GROUP_PROPERTIES.layout.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.position.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.size.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.effects.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.background.type,
	],
	image: [
		COMPONENT_STYLE_GROUP_PROPERTIES.layout.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.size.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.background.type,
	],
	errorText: [
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.background.type,
	],
	errorTextContainer: [
		COMPONENT_STYLE_GROUP_PROPERTIES.layout.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.position.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.spacing.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.typography.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.border.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.size.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.effects.type,
		COMPONENT_STYLE_GROUP_PROPERTIES.background.type,
	],
};

export { propertiesDefinition, stylePropertiesDefinition };
